import { render, staticRenderFns } from "./FundsHub.vue?vue&type=template&id=3992e0a8"
import script from "./FundsHub.vue?vue&type=script&lang=js"
export * from "./FundsHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports